import { Injectable } from '@angular/core';
import { upsertProducts } from '@epicuro-next/state/product-entities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

import {
  loadProductsSuccess,
  updateProductsWithDiscounts,
} from '../product-basket.actions';
import { selectCollapse } from '../product-basket.selectors';

@Injectable()
export class ProductEntitiesFromPbasketEffects {
  public updateProductEntitiesState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProductsSuccess, updateProductsWithDiscounts),
      concatLatestFrom(() => [this.store.pipe(select(selectCollapse))]),
      filter(([, collapse]) => collapse === false),
      map(([{ products }]) =>
        upsertProducts({
          products,
        }),
      ),
    ),
  );

  constructor(private actions$: Actions, private store: Store) {}
}
